import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { workflowAPI } from "../../utilities/api/workflowApi";

interface WorkflowState {
    workflows: any;
}

const initialState: WorkflowState = {
    workflows: [],
};

const workflowSlice = createSlice({
    name: 'stateWorkflow',
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(getAllWorkflows.fulfilled, (state, action) => {
            state.workflows = action.payload;
        })
    },
})

export const getAllWorkflows = createAsyncThunk(
    'stateWorkflow/getWorkflowsItems', 
    async () => {
        const response = await workflowAPI.getAllWorkflows();
        return response;
    }
)

export default workflowSlice.reducer;